import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.bundle.js";
import bootstrap from "bootstrap/dist/js/bootstrap.bundle.js";
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

// /* import the fontawesome core */
// import { library } from '@fortawesome/fontawesome-svg-core'

// /* import font awesome icon component */
// import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// /* import specific icons */
// import { faUserSecret } from '@fortawesome/free-solid-svg-icons'

// /* add icons to the library */
// library.add(faUserSecret)


createApp(App).use(store).use(router).use(bootstrap).mount("#app");
